import { useEffect } from "react";

export default function Investimentos() {
  useEffect(() => {
    document.title = "INVESTIMENTOS";
  }, []);

  return (
    <main className="flex h-full w-full flex-col items-center justify-center bg-background px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
        INVESTIMENTOS
      </h1>
    </main>
  );
}
